import { getGoalManifest } from './registry';

export const canEditGoal = (manifest) => (
  Boolean(manifest) && manifest.availability === 'active' && !manifest.unknownVersion
);

export const canPublishGoal = (manifest) => canEditGoal(manifest);

export const validateGoalConfig = (pluginKey, pluginVersion, config = {}) => {
  const manifest = getGoalManifest(pluginKey, pluginVersion);
  if (!canEditGoal(manifest)) return { goal: 'This goal version is read-only and cannot be published.' };
  if (pluginKey !== 'subscription') return { goal: 'Only Subscription campaigns are available in this release.' };
  if (config.qualification_mode && config.qualification_mode !== 'legacy_subscribed_boolean') {
    return { qualification_mode: 'Subscription V1 only supports legacy_subscribed_boolean' };
  }
  return {};
};
